import { Fragment } from 'react'
import { Link, Navigate } from 'react-router-dom'
import SEO from '../components/SEO'
import { CATEGORY_HUBS } from '../data/categoryHubs'
import { getToolsByCategory } from '../data/tools'
import './CategoryHub.css'

function CategoryHub({ hubId }) {
  const data = CATEGORY_HUBS.find((c) => c.id === hubId)
  if (!data) return <Navigate to="/" replace />

  const canonicalUrl = `/${data.route}`
  const tools = getToolsByCategory(hubId)
  const itemListElements = tools.map((t) => ({
    name: t.name,
    url: t.path,
  }))

  const otherHubs = CATEGORY_HUBS.filter((c) => c.id !== hubId)

  return (
    <>
      <SEO
        title={data.title}
        description={data.description}
        keywords={data.keywords}
        canonicalUrl={canonicalUrl}
        toolName={data.navTitle}
        schemaPageType="WebPage"
        faqItems={data.faqItems}
        itemListElements={itemListElements}
        modifiedTime={data.lastUpdated}
      />

      <div className="category-hub">
        <header className="category-hub-header">
          <nav className="category-hub-breadcrumb" aria-label="Breadcrumb">
            <Link to="/">Home</Link>
            <span aria-hidden="true">/</span>
            <span>{data.navTitle}</span>
          </nav>
          <h1>{data.h1}</h1>
        </header>

        <div className="category-hub-intro">
          {data.introParagraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>

        <section className="category-hub-tools" aria-labelledby="hub-tools-heading">
          <h2 id="hub-tools-heading">Tools in this category</h2>
          <ul className="category-hub-grid">
            {tools.map((tool) => (
              <li key={tool.slug}>
                <Link to={tool.path} className="category-hub-card">
                  <span className="category-hub-card-icon" aria-hidden="true">{tool.icon}</span>
                  <span className="category-hub-card-title">{tool.name}</span>
                  <span className="category-hub-card-blurb">{tool.blurb}</span>
                  <span className="category-hub-card-cta">Open tool →</span>
                </Link>
              </li>
            ))}
          </ul>
        </section>

        {data.faqItems?.length > 0 && (
          <section className="category-hub-faq" aria-labelledby="hub-faq-heading">
            <h2 id="hub-faq-heading">Frequently asked questions</h2>
            <dl>
              {data.faqItems.map((item, i) => (
                <Fragment key={i}>
                  <dt>{item.question}</dt>
                  <dd>{item.acceptedAnswer}</dd>
                </Fragment>
              ))}
            </dl>
          </section>
        )}

        <section className="category-hub-related" aria-labelledby="hub-related-heading">
          <h2 id="hub-related-heading">Other categories</h2>
          <p className="category-hub-muted">Browse another category.</p>
          <ul className="category-hub-related-list">
            {otherHubs.map((hub) => (
              <li key={hub.id}>
                <Link to={`/${hub.route}`}>{hub.navTitle}</Link>
                <span className="category-hub-muted"> — {getToolsByCategory(hub.id).length} tools</span>
              </li>
            ))}
          </ul>
          <p className="category-hub-back">
            <Link to="/">← All tools on home</Link>
          </p>
        </section>
      </div>
    </>
  )
}

export default CategoryHub
